module.exports = __webpack_public_path__ + "img/Processing.004d4cb3.svg";